import axios from 'axios';

export default {
    async serverAuthenticationFromPassword(context, { email, password }) {
        try {
            const res = await axios.post(context.getters.get_api_url + 'auth/login/', {
                email: email,
                password: password,
            });

            const token = res.data.token;
            const refresh_token = res.data.refresh_token;

            localStorage.setItem('refresh_token', refresh_token);
            context.commit('setToken', token);

            return true;
        } catch (err) {
            console.error(err);
            context.commit('changeErrorMsg', "Identifiant ou mot de passe incorrect");
            return false;
        }
    },
    // store/actions.js
    async refreshAccessToken(context) {
        try {
            const refresh_token = localStorage.getItem('refresh_token');
            if (!refresh_token) throw new Error('Pas de refresh token')
            const res = await axios.post(context.getters.get_api_url + 'auth/refresh/', { refresh_token });
            
            const token = res.data.token;
            const new_refresh_token = res.data.refresh_token;

            context.commit('setToken', token);
            if (new_refresh_token) {
                localStorage.setItem('refresh_token', new_refresh_token);
            } // sinon on garde l’ancien

            return true;
        } catch (err) {
            await context.dispatch('logout');
            throw err; // important : laisser l’appelant savoir que ça a échoué
        }
    },
    async logout(context) {
        try {
            await axios.post(context.getters.get_api_url + 'auth/logout/', { adminId: context.getters.getUserId });
        } catch (e) {
            // noop
        } finally {
            localStorage.removeItem('refresh_token'); // <= nettoie vraiment
            context.commit('setToken', undefined);
        }
    },
}